// removed by extract-text-webpack-plugin
module.exports = {"appWrapper":"index__appWrapper___2NKaR"};


//////////////////
// WEBPACK FOOTER
// ./src/app/index.scss
// module id = ./src/app/index.scss
// module chunks = 1